module.exports = __webpack_public_path__ + "img/bubble-checkmark_fill.a0f9226c.svg";